import React, { useState } from 'react';
import {
    ImageList,
    ImageListItem,
    ImageListItemBar
} from '@mui/material';
import Viewer from "react-viewer";
import { $authHost } from "../../../http";
import { useAuth } from "react-oidc-context";

const ImagesTab = ({ 
    images,
    darkMode = false
}) => {
    const auth = useAuth();
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    // Функция для получения URL stream изображения
    const getStreamImageUrl = (s3Id) => {
        const token = auth.user?.access_token;
        if (!token) return null;

        // Формируем URL с токеном в query параметре для stream endpoint
        return `${$authHost.defaults.baseURL}/apig/s3/files/${s3Id}/stream?token=${encodeURIComponent(token)}`;
    };

    // Обработчик открытия изображения в Viewer
    const handleImageClick = async (index) => {
        setActiveIndex(index);
        setVisible(true);
    };

    // Обработчик изменения активного изображения в Viewer
    const handleViewerChange = async (data, index) => {
        console.log(data, index)
        setActiveIndex(index);
    };

    if (!images || images.length === 0) {
        return (
            <div style={{ textAlign: 'center', color: '#666', fontSize: '14px', padding: '20px' }}>
                Изображения отсутствуют
            </div>
        );
    }

    return (
        <>
            <ImageList cols={3}  style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                {images.map((image, i) => {
                    return (
                        <ImageListItem key={image.id}>
                            <img
                                src={image.preview}
                                alt={image.name}
                                loading="lazy"
                                onClick={() => handleImageClick(i)}
                                style={{ cursor: 'pointer' }}
                            />
                            <ImageListItemBar
                                title={image.name}
                                subtitle={'@' + image.user}
                                sx={{
                                    '& .MuiImageListItemBar-title': {
                                        fontSize: '0.7rem',
                                        color: '#FFF'
                                    },
                                    '& .MuiImageListItemBar-subtitle': {
                                        fontSize: '0.6rem',
                                        color: '#AAA'
                                    }
                                }}
                            />
                        </ImageListItem>
                    )
                })}
            </ImageList>
            
            <Viewer
                visible={visible}
                onClose={() => setVisible(false)}
                onMaskClick={() => setVisible(false)}
                onChange={handleViewerChange}
                images={images.map(image => {
                    const streamUrl = getStreamImageUrl(image.s3Id);
                    return {
                        src: streamUrl || image.preview,
                        alt: image.name,
                        downloadUrl: streamUrl || image.preview
                    };
                })}
                activeIndex={activeIndex}
                zIndex={9999}
                downloadable={true}
                scalable={true}
                rotatable={true}
                zoomable={true}
                drag={true}
                downloadInNewWindow={true}
            />
        </>
    );
};

export default ImagesTab;
